import { QTextEdit } from "./QTextEdit";

export class QMLTextEdit extends QTextEdit {
  constructor() {
    super();
    this.fActiveSelection = true;
  }

  TEGetVAlignment() {
    return this.fVAlignment ? this.fVAlignment : "top";
  }
}
